/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser }) {
  const { currentUser } = initialState ?? {};
  return {
    isSuper: currentUser?.is_super === 1,
    isBackend: currentUser?.is_super === 1 || currentUser?.is_super === 2,
  };
}
